import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
const baseUrl = env.REACT_APP_BASE_URL;

export const fetchCloudKeys = createAsyncThunk(
  "fetchCloudKeys",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/byok/create_credentials`,
        {
          credentials: values,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      let errorMessage = "An unknown error occurred.";
      if (error?.response?.data?.errors) {
        if (Array.isArray(error.response.data.errors.base)) {
          errorMessage = error.response.data.errors.base[0];
        } else {
          errorMessage = error.response.data.errors;
        }
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const fetchNewCloudKeys = createAsyncThunk(
  "fetchNewCloudKeys",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/byok/create_new_credentials`,
        {
          credentials: values,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      let errorMessage = "An unknown error occurred.";
      if (error?.response?.data?.errors) {
        if (Array.isArray(error.response.data.errors.base)) {
          errorMessage = error.response.data.errors.base[0];
        } else {
          errorMessage = error.response.data.errors;
        }
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const uploadCloudKeys = createAsyncThunk(
  "uploadCloudKeys",

  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/byok/update_credentials`,
        {
          credentials: {
            access_key: values?.access_key,
            secret_access_key: values?.secret_access_key,
            session_token: values?.session_token,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      let errorMessage = "An unknown error occurred.";
      if (error?.response?.data?.errors) {
        if (Array.isArray(error.response.data.errors.base)) {
          errorMessage = error.response.data.errors.base[0];
        } else {
          errorMessage = error.response.data.errors;
        }
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const encryptCloudKeys = createAsyncThunk(
  "encryptCloudKeys",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/byok/encrypt_data`,
        {
          credentials: { key_id: values },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      let errorMessage = "An unknown error occurred.";
      if (error?.response?.data?.errors) {
        if (Array.isArray(error.response.data.errors.base)) {
          errorMessage = error.response.data.errors.base[0];
        } else {
          errorMessage = error.response.data.errors;
        }
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      // CommonToast({
      //   text: errorMessage,
      //   icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
      //   variant: "var(--error)",
      //   buttonNeeded: false,
      // });

      return rejectWithValue(errorMessage);
    }
  },
);

export const decryptCloudKeys = createAsyncThunk(
  "decryptCloudKeys",
  async (args, { rejectWithValue }) => {
    const { values, showToast = true } = args;
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/byok/decrypt_data`,
        {
          credentials: { key_id: values },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      let errorMessage = "An unknown error occurred.";
      if (error?.response?.data?.errors) {
        if (Array.isArray(error.response.data.errors.base)) {
          errorMessage = error.response.data.errors.base[0];
        } else {
          errorMessage = error.response.data.errors;
        }
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      if (showToast) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(errorMessage);
    }
  },
);

export const getEncryptionKeys = createAsyncThunk(
  "getEncryptionKeys",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/byok/get_credentials`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      // Show user-friendly error toast
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const cloudKeyList = createAsyncThunk(
  "cloudKeyList",
  async (values, { rejectWithValue }) => {
    const { showToast = false } = values;
    try {
      const response = await axiosInstance.get(`${baseUrl}/byok/list_keys`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      // Show user-friendly error toast
      if (showToast) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(errorMessage);
    }
  },
);

export const rotateCloudKeys = createAsyncThunk(
  "rotateCloudKeys",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/byok/rotate_keys`,
        {
          credentials: { key_id: values },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      let errorMessage = "An unknown error occurred.";
      if (error?.response?.data?.errors) {
        if (Array.isArray(error.response.data.errors.base)) {
          errorMessage = error.response.data.errors.base[0];
        } else {
          errorMessage = error.response.data.errors;
        }
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);

const byok = createSlice({
  name: "byok",
  initialState: {
    fetchCloudKeysLoading: null,
    fetchCloudKeysData: null,
    fetchCloudKeysError: null,
    encryptCloudKeysLoading: null,
    encryptCloudKeysData: null,
    encryptCloudKeysError: null,
    cloudKeyListLoading: null,
    cloudKeyListData: null,
    cloudKeyListError: null,
    cloudKeyListErrorMsg: null,
    encryptionKeysGetLoading: null,
    encryptionKeysGetData: null,
    encryptionKeysGetError: null,
    updateCloudKeysLoading: null,
    updateCloudKeysData: null,
    updateCloudKeysError: null,
    fetchNewCloudKeysLoading: null,
    fetchNewCloudKeysData: null,
    fetchNewCloudKeysError: null,
    decryptionKeysGetLoading: null,
    decryptionKeysGetData: null,
    decryptionKeysGetError: null,
    rotateKeysGetLoading: null,
    rotateKeysGetData: null,
    rotateKeysGetError: null,
  },
  reducers: {
    resetFetchKeys(state) {
      state.fetchCloudKeysLoading = null;
      state.fetchCloudKeysData = null;
      state.fetchCloudKeysError = null;
    },
    resetUpdateFetchKeys(state) {
      state.updateCloudKeysLoading = null;
      state.updateCloudKeysData = null;
      state.updateCloudKeysError = null;
    },
    resetNewFetchKeys(state) {
      state.fetchNewCloudKeysLoading = null;
      state.fetchNewCloudKeysData = null;
      state.fetchNewCloudKeysError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCloudKeys.pending, (state) => {
      state.fetchCloudKeysLoading = true;
    });
    builder.addCase(fetchCloudKeys.fulfilled, (state, action) => {
      state.fetchCloudKeysLoading = false;
      state.fetchCloudKeysData = action.payload;
    });
    builder.addCase(fetchCloudKeys.rejected, (state, action) => {
      state.fetchCloudKeysError = true;
      state.fetchCloudKeysLoading = false;
    });

    builder.addCase(fetchNewCloudKeys.pending, (state) => {
      state.fetchNewCloudKeysLoading = true;
    });
    builder.addCase(fetchNewCloudKeys.fulfilled, (state, action) => {
      state.fetchNewCloudKeysLoading = false;
      state.fetchNewCloudKeysData = action.payload;
    });
    builder.addCase(fetchNewCloudKeys.rejected, (state, action) => {
      state.fetchNewCloudKeysError = true;
      state.fetchNewCloudKeysLoading = false;
    });

    builder.addCase(encryptCloudKeys.pending, (state) => {
      state.encryptCloudKeysLoading = true;
    });
    builder.addCase(encryptCloudKeys.fulfilled, (state, action) => {
      state.encryptCloudKeysLoading = false;
      state.encryptCloudKeysData = action.payload;
    });
    builder.addCase(encryptCloudKeys.rejected, (state, action) => {
      state.encryptCloudKeysError = true;
      state.encryptCloudKeysLoading = false;
    });
    builder.addCase(decryptCloudKeys.pending, (state) => {
      state.decryptionKeysGetLoading = true;
    });
    builder.addCase(decryptCloudKeys.fulfilled, (state, action) => {
      state.decryptionKeysGetLoading = false;
      state.decryptionKeysGetData = action.payload;
    });
    builder.addCase(decryptCloudKeys.rejected, (state, action) => {
      state.decryptionKeysGetError = true;
      state.decryptionKeysGetLoading = false;
    });
    builder.addCase(cloudKeyList.pending, (state) => {
      state.cloudKeyListLoading = true;
    });
    builder.addCase(cloudKeyList.fulfilled, (state, action) => {
      state.cloudKeyListLoading = false;
      state.cloudKeyListData = action.payload;
    });
    builder.addCase(cloudKeyList.rejected, (state, action) => {
      state.cloudKeyListError = true;
      state.cloudKeyListLoading = false;
      state.cloudKeyListErrorMsg = action.payload;
    });
    builder.addCase(getEncryptionKeys.pending, (state) => {
      state.encryptionKeysGetLoading = true;
    });
    builder.addCase(getEncryptionKeys.fulfilled, (state, action) => {
      state.encryptionKeysGetLoading = false;
      state.encryptionKeysGetData = action.payload;
    });
    builder.addCase(getEncryptionKeys.rejected, (state, action) => {
      state.encryptionKeysGetError = true;
      state.encryptionKeysGetLoading = false;
    });

    builder.addCase(uploadCloudKeys.pending, (state) => {
      state.updateCloudKeysLoading = true;
    });
    builder.addCase(uploadCloudKeys.fulfilled, (state, action) => {
      state.updateCloudKeysLoading = false;
      state.updateCloudKeysData = action.payload;
    });
    builder.addCase(uploadCloudKeys.rejected, (state, action) => {
      state.updateCloudKeysError = true;
      state.updateCloudKeysLoading = false;
    });

    builder.addCase(rotateCloudKeys.pending, (state) => {
      state.rotateKeysGetLoading = true;
    });
    builder.addCase(rotateCloudKeys.fulfilled, (state, action) => {
      state.rotateKeysGetLoading = false;
      state.rotateKeysGetData = action.payload;
    });
    builder.addCase(rotateCloudKeys.rejected, (state, action) => {
      state.rotateKeysGetError = true;
      state.rotateKeysGetLoading = false;
    });
  },
});

export const { resetFetchKeys, resetUpdateFetchKeys, resetNewFetchKeys } =
  byok.actions;

export default byok.reducer;
